// src/routes/RequireAuth.js
import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { isProdHosted } from "../utils/cfAccess";

export default function RequireAuth() {
  const { isAuthed } = useContext(AuthContext);
  const location = useLocation();

  // 운영 배포(Cloudflare Access)면 SPA 내부 토큰 검사는 생략
  if (isProdHosted()) return <Outlet />;

  // 로컬/개발: 토큰 로그인 안 했으면 /token 으로
  if (!isAuthed) {
    return <Navigate to="/token" replace state={{ from: location }} />;
  }

  return <Outlet />;
}